import {CANDIDATE_SOURCE} from '/enum/candidateSource.enum';

export const getCandidateSource = (source: any) => {
  const candidateSource = [...CANDIDATE_SOURCE];
  return candidateSource.find(({id}) => id === source);
};
